import { render, staticRenderFns } from "./TicketWindow.vue?vue&type=template&id=13a82968&scoped=true"
import script from "./TicketWindow.vue?vue&type=script&lang=js"
export * from "./TicketWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a82968",
  null
  
)

export default component.exports